import React, { useState, useEffect } from "react";
import { Card, Button, Select, Typography, Spin } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import BrandColors from "@brand-colors";
import i18n from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { portalActions } from "store/portal-slice";
import { useDispatch } from "react-redux";
import { LANGUAGES } from "./../../constants/supported_lang";
import { usePageTitle } from "helpers/usePageTitle";

const { Title } = Typography;
const { Option } = Select;

const Language = () => {
  usePageTitle("LANGUAGE.PAGE_TITLE", `Language Selection - ${process.env.REACT_APP_PRODUCT}`);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const agreementText = location.state && location.state.agreementText;
  const renderHtml = location.state && location.state.renderHtml;
  const languageConfirmed = location.state && location.state.languageConfirmed;
  console.log("agreementText", agreementText);

  const { rawSurveyData } = location.state;
  console.log("rawSurveyData+++", rawSurveyData);

  const { getSurevyData, preferredLanguageData } = useSurveySrv();
  const [selectedLanguage, setSelectedLanguage] = useState("en"); // Default to English
  const [response, setResponse] = useState(null); // Hold survey data
  const [loading, setLoading] = useState(true); // Track loading state
  useEffect(() => {
    const preferredLang = localStorage.getItem("preferredLanguageForSurvey");
    const languageToSet = preferredLang || "en";

    setSelectedLanguage(languageToSet);
    i18n.changeLanguage(languageToSet);
    dispatch(portalActions.updateSurveyLanguageState(languageToSet));

    if (!preferredLang) {
      localStorage.setItem("preferredLanguageForSurvey", languageToSet);
    }
  }, []);

  const handleLanguageChange = (value) => {
    console.log("value+++", value);
    setSelectedLanguage(value === null ? "en" : value);
    localStorage.setItem(
      "preferredLanguageForSurvey",
      value === null ? "en" : value
    );
    i18n.changeLanguage(value === null ? "en" : value); // Update i18n language
    // dispatch(portalActions.updateLanguageState(value));
    dispatch(
      portalActions.updateSurveyLanguageState(value === null ? "en" : value)
    );
  };
  const preferredLanguageForSurvey = localStorage.getItem(
    "preferredLanguageForSurvey"
  );
  console.log("preferredLanguageForSurvey", preferredLanguageForSurvey);
  const handleProceed = () => {
    // if (!response) {
    //   console.error("Survey data is not available yet.");
    //   return;
    // }

    // try {
    //   // Find the selected language's ID
    //   const selectedLanguageData = LANGUAGES.find(
    //     (lang) => lang.code === selectedLanguage
    //   );
    //   const selectedLanguageId = selectedLanguageData?.id || null;

    //   if (!selectedLanguageId) {
    //     console.error(
    //       "No matching language ID found for the selected language."
    //     );
    //     return;
    //   }

    //   console.log("Survey Response:", response);

    //   await preferredLanguageData({
    //     PatientID: response?.PatientID,
    //     PatientActivityID: response?.PatientActivityID,
    //     PreferredLanguage: selectedLanguageId,
    //   });
    // } catch (error) {
    //   console.error("Error in preferredLanguageData:", error);
    // }

    // Logging and navigation
    console.log("Selected Language:", selectedLanguage);
    navigate("/member/memberportalagreement", {
      state: {
        rawSurveyData: rawSurveyData,
        agreementText: agreementText,
        renderHtml: renderHtml,
      },
    });
  };

  //const isDisabled = response?.PreferredLanguage !== 0;
  const isDisabled = languageConfirmed === true;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Card style={{ width: 400, padding: 20, textAlign: "center" }}>
        <Title level={2}>Choose Your Preferred Language</Title>

        <Select
          value={selectedLanguage}
          onChange={handleLanguageChange}
          style={{ width: "100%", marginBottom: 20 }}
          // disabled={isDisabled}
        >
          {LANGUAGES.map((lang) => (
            <Option key={lang.code} value={lang.code}>
              {lang.label}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          icon={<ArrowRightOutlined />}
          onClick={handleProceed}
          style={{ width: "100%", backgroundColor: BrandColors.BUTTON_BG }}
          id="language-proceed-btn"
        >
          Proceed
        </Button>
      </Card>
    </div>
  );
};

export default Language;
